"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTraceFieldGroups = exports.hasTraceFieldGroups = exports.getScoreFieldGroups = exports.getObservationFieldGroups = exports.EXPORT_FIELD_GROUPS = exports.TRACE_EXPORT_FIELDS = exports.TRACE_EXPORT_FIELD_GROUPS = exports.SCORE_EXPORT_GROUP_FIELDS = exports.SCORE_EXPORT_CORE_FIELDS = exports.SCORE_EXPORT_FIELD_GROUPS = void 0;
const observation_field_groups_1 = require("./observation-field-groups");
/**
 * Field groups of the scores blob export. Named with a `score_` prefix so they
 * never collide with an observation group of the same column (e.g. the
 * observation `metadata` group).
 *
 * Score groups are opt-in: they are not part of any default selection, so
 * existing exports keep their columns and size until a group is selected.
 */
exports.SCORE_EXPORT_FIELD_GROUPS = [
    "score_metadata",
    "score_provenance",
];
/**
 * Columns of every scores export row, in output order. Always exported, so
 * they are not a stored field group; settings show them as a locked "Core"
 * group. Optional group columns are appended after these.
 */
exports.SCORE_EXPORT_CORE_FIELDS = [
    "id",
    "timestamp",
    "project_id",
    "environment",
    "trace_id",
    "observation_id",
    "session_id",
    "dataset_run_id",
    "name",
    "value",
    "source",
    "comment",
    "data_type",
    "string_value",
    "created_at",
    "updated_at",
];
/**
 * Columns each score group adds, appended after the core columns in
 * `SCORE_EXPORT_FIELD_GROUPS` order. Provenance holds the references to where
 * a score came from: author, score config, annotation queue, evaluator.
 */
exports.SCORE_EXPORT_GROUP_FIELDS = {
    score_metadata: ["metadata"],
    score_provenance: [
        "author_user_id",
        "config_id",
        "queue_id",
        "evaluator_id",
        "evaluation_rule_id",
        "execution_trace_id",
    ],
};
/**
 * Field groups of the legacy traces blob export, prefixed with `trace_` like
 * the score groups. `trace_core` is always exported; it is stored to mark the
 * trace selection as configured.
 *
 * A selection without any trace group exports every trace column, so
 * integrations saved before trace groups existed keep their export unchanged.
 */
exports.TRACE_EXPORT_FIELD_GROUPS = [
    "trace_core",
    "trace_io",
    "trace_metadata",
];
/**
 * Columns of the traces export and the group each belongs to, in the column
 * order of the full export (kept stable so a full selection is unchanged).
 */
exports.TRACE_EXPORT_FIELDS = [
    { field: "id", group: "trace_core" },
    { field: "timestamp", group: "trace_core" },
    { field: "name", group: "trace_core" },
    { field: "environment", group: "trace_core" },
    { field: "project_id", group: "trace_core" },
    { field: "metadata", group: "trace_metadata" },
    { field: "user_id", group: "trace_core" },
    { field: "session_id", group: "trace_core" },
    { field: "release", group: "trace_core" },
    { field: "version", group: "trace_core" },
    { field: "public", group: "trace_core" },
    { field: "bookmarked", group: "trace_core" },
    { field: "tags", group: "trace_core" },
    { field: "input", group: "trace_io" },
    { field: "output", group: "trace_io" },
    { field: "created_at", group: "trace_core" },
    { field: "updated_at", group: "trace_core" },
];
/**
 * Every value that can be stored in an integration's `exportFieldGroups`.
 * Each group belongs to exactly one exported table; split a selection with
 * `getObservationFieldGroups` / `getScoreFieldGroups` /
 * `getTraceFieldGroups` before handing it to a table's query.
 */
exports.EXPORT_FIELD_GROUPS = [
    ...observation_field_groups_1.OBSERVATION_FIELD_GROUPS_FULL,
    ...exports.SCORE_EXPORT_FIELD_GROUPS,
    ...exports.TRACE_EXPORT_FIELD_GROUPS,
];
const getObservationFieldGroups = (groups) => groups.filter((group) => observation_field_groups_1.OBSERVATION_FIELD_GROUPS_FULL.includes(group));
exports.getObservationFieldGroups = getObservationFieldGroups;
const getScoreFieldGroups = (groups) => groups.filter((group) => exports.SCORE_EXPORT_FIELD_GROUPS.includes(group));
exports.getScoreFieldGroups = getScoreFieldGroups;
/** True when the selection configures the traces export (any trace group stored). */
const hasTraceFieldGroups = (groups) => groups.some((group) => exports.TRACE_EXPORT_FIELD_GROUPS.includes(group));
exports.hasTraceFieldGroups = hasTraceFieldGroups;
/**
 * Trace groups to export: all of them when the selection holds no trace group,
 * otherwise the selected ones plus the always-exported `trace_core`.
 */
const getTraceFieldGroups = (groups) => (0, exports.hasTraceFieldGroups)(groups)
    ? exports.TRACE_EXPORT_FIELD_GROUPS.filter((group) => group === "trace_core" || groups.includes(group))
    : [...exports.TRACE_EXPORT_FIELD_GROUPS];
exports.getTraceFieldGroups = getTraceFieldGroups;
